
import CardsLoader from '~/components/pages/education/ProgramsList/CardsLoader.vue'

export default {
  name: 'ProgramListLoader',
  components: { CardsLoader }
}
